import { Field } from '@headlessui/react';
import { forwardRef } from 'react';
import WarningIcon from '@/assets/warning.svg';
import { textFieldErrorMessages } from '@/constants/text-field-error-messages';
import { Description } from './description';
import { Label } from './label';
import { TextInput, TextInputProps } from './text-input';

export type TextFieldProps = TextInputProps & {
  description?: string;
  label: string;
};

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ description, error, label, required, ...props }, ref) => (
    <div className="w-full max-w-md">
      <Field>
        <div className="flex flex-col">
          <Label>{label}</Label>
          {description && <Description>{description}</Description>}
        </div>
        <div className="relative mt-2">
          <TextInput {...props} error={error} ref={ref} required={required} />
          {error && (
            <WarningIcon
              aria-hidden="true"
              className="text-warning pointer-events-none absolute top-2/4 right-2 h-5 w-5 -translate-y-2/4"
            />
          )}
        </div>
        {error && typeof error.type === 'string' && (
          <span
            className="mt-2 block text-sm font-normal text-red-600"
            role="alert"
          >
            {error.message ? error.message : textFieldErrorMessages[error.type]}
          </span>
        )}
      </Field>
    </div>
  ),
);
